import type { FC } from 'react';

import { EPropertySettingTypes } from 'api/meta/enums/nodes/properties/EPropertySettingTypes';
import { DiffText } from 'pages/projects/projectPage/selectedProject/projectHistory/DiffText';
import type { PropertySettingTypes } from 'state/selectedTemplate/selectedTemplateStore';

export interface EventHistoryDiffTextProps {
  oldText: string;
  newText: string;
  keyPrefix: string;
  fieldPropertyType: PropertySettingTypes;
}

export const EventHistoryDiffText: FC<EventHistoryDiffTextProps> = ({
  oldText,
  newText,
  keyPrefix,
  fieldPropertyType
}) => {
  const diffType = fieldPropertyType !== EPropertySettingTypes.Text ? 'lines' : 'words';

  return <DiffText oldText={oldText} newText={newText} diffType={diffType} keyPrefix={keyPrefix} />;
};
